"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = require("react-dom");
const react_1 = require("react");
const classnames_1 = require("classnames");
const app_1 = require("app");
const useTooltip_1 = require("./useTooltip");
const hasTouch = (0, app_1.isTouchDevice)();
const Tooltip = ({ trigger = 'hover', placement = 'bottom-start', id, className, wrapperAs: Wrapper = 'div', isDisabled, children, title, content, contentClassName, modifiers = [], isTouchActivated = hasTouch, onShow, onHide, isPortalRendering, showCloseButton = true, container = document.body, tooltipContainerClassName = 'tooltip-container', }) => {
    const a11yHint = (0, react_1.useRef)(null);
    const handleShow = (0, react_1.useCallback)(() => {
        if (!isDisabled && a11yHint.current) {
            a11yHint.current.innerHTML = content;
        }
        if (onShow) {
            onShow();
        }
    }, [isDisabled, content, onShow]);
    const handleHide = (0, react_1.useCallback)(() => {
        if (a11yHint.current) {
            a11yHint.current.innerHTML = '';
        }
        if (onHide) {
            onHide();
        }
    }, [onHide]);
    const { isOpened, hide, reference, tooltip } = (0, useTooltip_1.useTooltip)(isTouchActivated ? 'click' : trigger, {
        strategy: 'fixed',
        placement,
        modifiers,
    }, {
        isDisabled,
        onShow: handleShow,
        onHide: handleHide,
    });
    const TooltipElement = (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsxs)("div", { id: id, className: (0, classnames_1.default)(tooltipContainerClassName, 'w-full max-w-[350px]'), children: [isTouchActivated && showCloseButton && ((0, jsx_runtime_1.jsx)("button", { className: (0, classnames_1.default)(`${useTooltip_1.popperElementBaseClass}-close`, 'hidden'), onClick: hide })), (0, jsx_runtime_1.jsxs)("div", Object.assign({}, tooltip, { className: (0, classnames_1.default)(useTooltip_1.popperElementBaseClass, contentClassName, 'p-md bg-fill-primary absolute rounded-3xl shadow-md z-[1060] max-w-[350px]', {
                    'touch-active': isTouchActivated,
                }), children: [title && (0, jsx_runtime_1.jsx)("div", { className: "subtitle-lg-moderate", children: title }), (0, jsx_runtime_1.jsx)("div", { className: "body-md text-secondary", children: content })] }))] })), [
        tooltipContainerClassName,
        content,
        contentClassName,
        hide,
        id,
        isTouchActivated,
        showCloseButton,
        tooltip,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Wrapper, Object.assign({}, reference, { className: (0, classnames_1.default)('inline', className, {
                    disabled: isDisabled,
                    active: isOpened,
                }), children: children })), isOpened && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isPortalRendering ? ReactDOM.createPortal(TooltipElement, container) : TooltipElement }))] }));
};
exports.default = Tooltip;
const renderTooltip = (root, props, content) => {
    return (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(Tooltip, Object.assign({}, props, { children: content })), root);
};
exports.renderTooltip = renderTooltip;
